<template>
    <div class="body_monban" >
      <el-tabs  style="height: 200px;" v-model="activeName">
      <el-tab-pane label="设备管理"  name="mac"><mac :admin_flag="1"></mac></el-tab-pane>
      <el-tab-pane label="设备二维码一览" name="kucunEwm"><kucunEwm :admin_flag="1"></kucunEwm></el-tab-pane>
    </el-tabs>
  
    </div>
  </template>
  <style>
  .body_moban{
    padding-top: 100px;
  }
  </style>
  <script>
  import mac from './mac.vue';
  import kucunEwm from './kucunEwm.vue';
 
  export default {
    components: {
      mac: mac,
        kucunEwm: kucunEwm
    },
  
    data() {
      return {
        // 获取用户列表参数
        activeName: 'mac'
      };
    },
    props: [],
   
    watch: {
   
    },
    created() {
   
    },
    mounted() {
   
    }
  }
  </script>
